var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-coupon-container"},[(_vm.ciReport !== null)?_c('div',[_c('CIReport',{attrs:{"accessToken":_vm.ciReport.accessToken,"embedUrl":_vm.ciReport.embedUrl,"basicFilter":_vm.ciReport.basicFilter}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }